import { createAsyncActionTypes } from '../../util/createLifeomicActionTypes';

const asyncActions = createAsyncActionTypes(['FETCH_CUSTOM_APPS']);

export default {
  ...asyncActions,
};
